module.exports = __webpack_public_path__ + "static/media/h2.31c5e618.png";